const guiColors = {
    'motion-primary': 'rgb(68, 227, 40)',
    'motion-primary-transparent': 'rgba(78, 201, 41, 0.9)',
    'motion-tertiary': 'rgb(112, 204, 51)',

    'looks-secondary': 'rgb(119, 216, 50)',
    'looks-transparent': 'rgba(98, 255, 77, 0.35)',
    'looks-light-transparent': 'rgba(124, 255, 77, 0.15)',
    'looks-secondary-dark': 'hsl(104, 42.20%, 51.20%)',

    'extensions-primary': 'hsl(91, 85.40%, 65.10%)',
    'extensions-tertiary': 'rgb(15, 189, 41)',
    'extensions-transparent': 'hsla(142, 85.40%, 65.10%, 0.35)',
    'extensions-light': 'hsl(100, 57.90%, 85.10%)',

    'drop-highlight': '#a7ff8c'
};

const blockColors = {
    checkboxActiveBackground: 'rgb(97, 255, 76)',
    checkboxActiveBorder: 'rgb(92, 204, 51)'
};

export {
    guiColors,
    blockColors
};
